// extracted by mini-css-extract-plugin
export default {"wrapper":"oL","content":"pL","firstSection":"qL","text":"rL","table":"sL","tableText":"tL","row":"uL","column_2":"vL","column_1":"wL","column_3":"xL"};
    if(module.hot) {
      // 1715188236810
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  